"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

/**
 * 
 * @prettier
 */
function memoize(fn) {
  var called = false;
  var lastInput = null;
  var lastOutput = null;
  return function (input) {
    if (called && input === lastInput) {
      return lastOutput;
    }

    called = true;
    lastInput = input;
    return lastOutput = fn(lastInput);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-normalize-on-blur/util/memoize.js
// module id = 6364
// module chunks = 6